import { useCallback } from 'react'
import { useSync } from '../context/SyncContext'
import { parseLocalDateTime, toDateKey } from '../utils/dateUtils'

export function useEvents() {
  const { events, addEvent, updateEvent, deleteEvent } = useSync()
  const visible = events.filter((e) => !e.deletedAt)

  const eventsOnDay = useCallback(
    (day: Date) => {
      const key = toDateKey(day)
      return visible
        .filter((e) => toDateKey(parseLocalDateTime(e.start)) === key)
        .sort((a, b) => a.start.localeCompare(b.start))
    },
    [visible],
  )

  const hasEventsOnDay = useCallback(
    (day: Date) => {
      const key = toDateKey(day)
      return visible.some((e) => toDateKey(parseLocalDateTime(e.start)) === key)
    },
    [visible],
  )

  return {
    events: visible,
    addEvent,
    updateEvent,
    deleteEvent,
    eventsOnDay,
    hasEventsOnDay,
  }
}
